import { Component,  OnInit } from '@angular/core';
import { BaseComponent } from '../base-component/base.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { SharedApiService } from '@shared-features/services/shared-api.service';
import { Announcement } from '@shared-features/models/announcement.model';
import { MatDialogRef } from '@angular/material/dialog';
import { debounceTime } from 'rxjs/operators';
import { LookupType } from '@shared/enums/lookup-type.enum';
import { modelToLookup } from '@shared/utils/model-to-lookup.util';
import { CustomerStatus } from '@shared-features/enums/customer-status.enum';

@Component({
  selector: 'app-announcement-dialog',
  templateUrl: './announcement-dialog.component.html',
  styleUrls: ['./announcement-dialog.component.scss']
})
export class AnnouncementDialogComponent extends BaseComponent implements OnInit {
  form:FormGroup
  announcement:Announcement
  showDialog:boolean = false
  readonly LookupType = LookupType;
  minDate: Date = new Date();

  constructor(
    
    private formBuilder: FormBuilder,
    private sharedApiService:SharedApiService,
    private matDialogRef:MatDialogRef<AnnouncementDialogComponent>
  ) {
    super()
  }

  ngOnInit() {
    this.getAnnouncement()
  }

  initForm(){
    this.form = this.formBuilder.group({
      message: [this.announcement?.message ,[Validators.required , Validators.maxLength(100)]],
      urlName:[this.announcement?.urlName],
      url:[this.announcement?.url],
      isForCustomer: [this.announcement?.isForCustomer],
      isForAdmin: [this.announcement?.isForAdmin],
      customers: [this.announcement?.customers?.length
        ? this.announcement?.customers.map((i)=> modelToLookup(i,'id', 'value')): []
      ],
      expiryDate: [this.announcement?.expiryDate ? new Date(this.announcement.expiryDate) : null, [Validators.required]]
    })

    this.form.get("url").valueChanges.pipe(
      debounceTime(300)
    ).subscribe(() => {
      this.updateUrlNameValidation();
    });
  }

  updateUrlNameValidation() {
    const urlControl = this.form.get('url');
    const urlNameControl = this.form.get('urlName');

    if (urlControl.value) {
      urlNameControl.markAsTouched();
      urlNameControl.setValidators(Validators.required);
    } else {
      urlNameControl.clearValidators();
    }
    urlNameControl.updateValueAndValidity();
  }

  getAnnouncement(){
    this.load(this.sharedApiService.getAnnouncement(),{isLoadingTransparent:true}).subscribe((announcement) => {
      this.announcement = announcement
      this.showDialog = true
      this.initForm()
    })
  }

  setAnnouncement(){
    const {message,url,isForCustomer,isForAdmin,urlName, expiryDate} = this.form.value
    const customerIds = this.form?.value?.customers?.map(customer => customer.id).filter(id => id !== CustomerStatus.All) || [];
    const payload={
      message,
      urlName,
      url,
      isForCustomer,
      isForAdmin,
      customerIds: customerIds,
      expiryDate: expiryDate ? expiryDate.toISOString() : null
    }

    this.load(this.sharedApiService.setAnnouncement(payload),{isLoadingTransparent:true}).subscribe(res=>{
      this.matDialogRef.close()
    })
  }

}
